module.exports = __webpack_public_path__ + "static/media/8.bbfc26fe.jpg";